<script lang="ts">
	import SbRichtext from '../components/sbRichtext.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import ArrowRight from '$lib/icons/arrowRight.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			text: ISbRichtext;
			cta_label: string;
			cta_anchor: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="my-8 py-8 lg:my-16 lg:py-16">
	<PageGrid16 margin>
		<div class="col-span-full lg:col-start-2 lg:col-end-[16]">
			<div
				class="text-[36px]/[112%] tracking-[-.36px] text-brown-1 lg:text-[64px]/[110%] lg:tracking-[-.64px]"
			>
				<SbRichtext text={content.text} />
			</div>
			<div class="mt-8 flex">
				<Button href="#{content.cta_anchor}" class="btn-secondary btn-large btn-brown"
					><span>{content.cta_label}</span>
					<ArrowRight class="h-6 w-6 rotate-90" /></Button
				>
			</div>
		</div>
	</PageGrid16>
</div>
